import React from "react";
import styles from "pages/StepPages/StepFive/SelectionCategories/SelectionCategories.module.sass";
import Row from "pages/StepPages/StepFive/SelectionCategories/Row";

const Title = ({ index, title }: any) => {
	return (
		<div className={styles.tr}>
			<div className={styles.td}>{index}</div>
			<div className={styles.td}>{title}</div>
			<div className={styles.td} />
			<div className={styles.td} />
			<div className={styles.td} />
			<div className={styles.td} />
		</div>
	);
};

const List = ({ row, sectionIndex, mIndex }: any) => {
	return (
		<div data-comment-false={true}>
			{row.title && <Title index={mIndex} title={row.title} />}
			{row.listOfB.map((_: any) => (
				<Row
					rowIndex={!row.title ? row.stringId : ""}
					key={_.stringId}
					subRow={_}
					sectionIndex={sectionIndex}
					mIndex={mIndex}
					bIndex={_.stringId}
				/>
			))}
		</div>
	);
};

export default List;
